import { mapActions, mapGetters } from "vuex";

export const drMixin = {
  computed: {
    ...mapGetters({
      drs: "dr/list/items",
      drsIsLoading: "dr/list/isLoading",
    }),
  },
  methods: {
    ...mapActions({
      getDrs: "dr/list/getItems",
    }),
  },
};
